module.exports = __webpack_public_path__ + "static/01_transition_szep-9e219bcb05eb172af9940d48f0e57b08.png";